// @ts-nocheck
import React from 'react';
import { useLocation } from 'react-router-dom';
import { FIELD_TYPES } from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constant';
import AttachmentUploader from './AttachmentUploader';

const AttachmentPreview = ({
  field,
  tableId,
  rowIndex,
  colIndex,
  updateAnswer,
}) => {
  const location = useLocation();
  const { pathname } = location;

  const isClientSideUpload = !(
    pathname.includes('add-response') || pathname.includes('edit-response')
  );

  const handleUpdateAttachments = (attachments) => {
    updateAnswer(tableId, rowIndex, colIndex, attachments);
  };

  return (
    <AttachmentUploader
      content={field}
      isClientSideUpload={isClientSideUpload}
      attachmentKey="answer"
      attachmentAlignment="column"
      attachmentType={field.type}
      inputLabel={
        field.type === FIELD_TYPES.IMAGES
          ? 'Click/Drag here to upload images'
          : 'Click/Drag here to upload files'
      }
      inputLabelStyle={{ fontSize: '10px' }}
      handleUpdateAttachments={handleUpdateAttachments}
    />
  );
};

export default AttachmentPreview;
